import {create} from 'zustand';
import {SummaryChangeDrawerStore} from './types';

const useSummaryChangeDrawerStore = create<SummaryChangeDrawerStore>(set => ({
	summaryChangeDrawer: false,
	setSummaryChangeDrawer: value => set({summaryChangeDrawer: value}),
}));

export {useSummaryChangeDrawerStore};
